import { useDispatch, useSelector } from 'react-redux';
import {
  selectMapCenter,
  selectMapZoom,
  setMapCenterAndZoom,
} from '../../../redux/store/ui/map';
import React, { useEffect, useRef, useState } from 'react';
import getBoundsFromPoints from '../../../utils/getBoundsFromPoints';
import getZoomFromBounds from '../../../utils/getZoomFromBounds';
import fixGeoJSONCoordinates from '../../../utils/fixGeoJSONCoordinates';
import MapGL from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import AreaPolygon from './AreaPolygon';

const FILTER_BAR_OFFSET = 100;

const MapView = ({ selectedArea }) => {
  const dispatch = useDispatch();
  const center = useSelector(selectMapCenter);
  const zoom = useSelector(selectMapZoom);
  const mapEl = useRef(null);
  const [mapReady, setMapReady] = useState(false);

  const initialViewport = {
    width: 300,
    height: 300,
    latitude: center.lat,
    longitude: center.lng,
    zoom: zoom || 15,
  };
  const [viewport, setViewport] = useState(initialViewport);

  const fitBounds = (points) => {
    const bounds = getBoundsFromPoints(points);
    const center = {
      lat: (bounds.north + bounds.south) / 2,
      lng: (bounds.east + bounds.west) / 2,
    };
    const divSize = {
      width: 300,
      height: 300 - FILTER_BAR_OFFSET,
    };

    const _zoom = getZoomFromBounds(bounds, divSize);
    dispatch(setMapCenterAndZoom({ center, zoom: _zoom }));
  };

  useEffect(() => {
    if (!selectedArea?.geoJSONData || !mapReady) return;

    const areaWithGeoJson = fixGeoJSONCoordinates(selectedArea.geoJSONData);
    const coordinates = areaWithGeoJson.features[0].geometry.coordinates[0];

    setTimeout(() => {
      const map = mapEl.current?.getMap?.();
      if (map) {
        map.resize();
        setTimeout(() => fitBounds(coordinates), 100);
      }
    }, 100);
  }, [selectedArea, mapReady]);

  useEffect(() => {
    if (center && typeof zoom === 'number') {
      setViewport((prev) => ({
        ...prev,
        latitude: center.lat,
        longitude: center.lng,
        zoom: zoom || 15,
      }));
    }
  }, [center, zoom]);

  const handleLoad = () => {
    setMapReady(true);
  };

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <MapGL
        ref={mapEl}
        {...viewport}
        width="100%"
        height="100%"
        onViewportChange={(viewport) => setViewport(viewport)}
        onLoad={handleLoad}
        mapboxApiAccessToken={process.env.VITE_MAPBOX_KEY}
        dragRotate={false}
        touchRotate={false}
        attributionControl={false}
        scrollZoom={false}
        dragPan={false}
      >
        {selectedArea && <AreaPolygon />}
      </MapGL>
    </div>
  );
};

export default MapView;
